import React from "react";
import Chart from "react-apexcharts";

const RadialBarChart = ({ percentage,valueItem }) => {
  console.log(valueItem)
  const options = {
    chart: {
      height: 200,
      type: "radialBar",
      offsetY: -40,
    },
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 135,
        dataLabels: {
          name: {
            fontSize: "16px",
            color: "#F42EBF",
            offsetY: -10,

          },
          value: {
            offsetY: 10,
            fontSize: "12px",
            color: "#F42EBF",
            formatter: function (val) {
              return val + "%";
            },
          },
        },
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        shadeIntensity: 0.15,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 50, 65, 91],
        colorStops: [
          {
            offset: 0,
            color: "#F42EBF", // Bright Red at the start
            opacity: 1,
          },
          {
            offset: 100,
            color: "#F42EBF", // Darker Red at the end
            opacity: 1,
          },
        ],
      },
    },
    stroke: {
      dashArray: 2,
    },
    labels: [`${valueItem}` + " Mn "],
  };

  const series = [percentage]; // Data for the chart

  return (
    <div>
      <Chart options={options} series={series} type="radialBar" width={200} height={200} />
    </div>
  );
};

export default RadialBarChart;
